import {
  Accordion as MUIAccordion,
  AccordionDetails as MUIAccordionDetails,
  AccordionSummary as MUIAccordionSummary,
} from '@mui/material';

import { withStyles } from 'tss-react/mui';

export const Accordion = withStyles(MUIAccordion, ({
  root: {
    background: 'transparent',
  }
}));

export const AccordionSummary = withStyles(MUIAccordionSummary, ({
  root: {
    padding: 0,

    '&.Mui-expanded': {
      minHeight: '48px',
    }
  },

  content: {
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    }
  }
}));

export const AccordionDetails = withStyles(MUIAccordionDetails, ({
  root: {
    padding: 0,
  }
}));
